<div class="flex text-slate-500">
  <div class="pr-2.5">
    <svg class="w-5 h-5 text-slate-300">
      <use xlink:href="assets/icons/symbols.svg#info"></use>
    </svg>
  </div>

  <div class="text-sm">
    <ng-content/>
  </div>
</div>
